import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@dxp/core/environment';
import { LOGGER_REQUEST_NAME } from '@dxp/core/types';

@Injectable({
    providedIn: 'root',
})
export class DirectoryApiService {
    readonly #http = inject(HttpClient);

    getPhoto(): Observable<Blob | null> {
        return this.#http.get(`${environment.directoryUrl}/me/photo`, {
            responseType: 'blob',
            context: new HttpContext().set(
                LOGGER_REQUEST_NAME,
                'Directory Service (Get Photo)',
            ),
        });
    }
}
